import { render, staticRenderFns } from "./SubscribeButton.vue?vue&type=template&id=b2041ab4&scoped=true"
import script from "./SubscribeButton.vue?vue&type=script&lang=js"
export * from "./SubscribeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2041ab4",
  null
  
)

export default component.exports